/* eslint-disable */

const Menu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
  },
  {
    title: 'Users',
    group: 'apps',
    name: 'Users',
    icon: 'assignment_ind',
  },
    {
        title: 'Forms & Controls',
        group: 'forms',
        name: 'formulaire',
        icon: 'edit',
    },

    {
        title: 'Requests',
        group: 'apps',
        name: 'Requests',
        icon: 'shopping_cart',
    }, {
        title: 'Rapports',
        group: 'apps',
        name: 'Rapports',
        icon: 'highlight_off',
    }, {
        title: 'Settings',
        group: 'apps',
        name: 'Settings',
        icon: 'settings',
    },

];
// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js